export const phone = '07532328412'
export const phoneReadable = '07532 328 412'
export const email = 'caroline@carolinechetwood.co.uk'
export const linkedIn =
  'http://uk.linkedin.com/pub/caroline-chetwood/48/256/a0a'
export const skype = 'caroline.chetwood'
export const siteName = 'Caroline Chetwood'
